import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { setupAssets } from '@/plugins/assets';
import 'normalize.css'
// 组册全局组件
function setupPlugins() {
   // 引入静态资源
   setupAssets();
}

createApp(App).use(store).use(Antd).use(router).mount('#app')

setupPlugins()
